<template>
	<div class="font-tag">
		<div class="content" :style="{ border: `0.09rem solid ${color}`, color }">
			<slot></slot>
		</div>
	</div>
</template>

<script setup>
defineProps({
	color: {
		type: String,
		default: '#333',
	},
});
</script>

<style scoped lang="scss">
.font-tag {
	display: flex;
	align-items: center;

	.content {
		height: 1.25rem;
		line-height: 1.1rem;
		border-radius: 0.25rem;
		padding: 0 0.25rem;
		box-sizing: border-box;
		font-family: 思源黑体;
		font-size: 0.83rem;
		font-weight: normal;
	}
}
</style>
